import { Maps } from 'js/components/Maps/index.js';
import { branchSvg, paypointSvg } from './common/helper';

export class CustomMap extends Maps.GoogleMapsEnterprise {
  static initClass() {
    Maps.FactoryForProvider.Google = (data) => new CustomMap(data);
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.CustomMap";
  }

  constructor(args) {
    super(args);
    this.pinWidth = 39;
    this.pinHeight = 50;
    this.loc = this.locs.length > 0 ? this.locs[0] : null;
  }

  svgPin() {
    if (this.loc && this.loc.isPayPoint)
      return paypointSvg;
    return branchSvg;
  }

  setOffsetCenter(latlng) {
    let newCenterLatLng = this.offsetLatLng(latlng, 0, 0);
    this.map.panTo(newCenterLatLng);
  }
}

CustomMap.initClass();
